import { NavLink } from "react-router-dom";
import { DesignV2Scope } from "../design-v2";
import "./bottomTabs.css";

/*
 * Canonical Design V2 bottom navigation (Phase 11A).
 *
 * There is exactly one bottom navigation component: no V1 fallback, no flag.
 * WHICH routes render it stays MainLayout's decision (focus-mode hiding), and
 * this component makes no assumption about it.
 *
 * Icons are local inline SVG on purpose. Material Symbols is retired from this
 * surface (D25) and no icon dependency or generic Icon abstraction is
 * introduced for it.
 */

function HomeIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" {...props}>
      <path
        d="M4 10.2 12 4l8 6.2V19a1 1 0 0 1-1 1h-4v-5H9v5H5a1 1 0 0 1-1-1v-8.8Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ProgramIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" {...props}>
      <rect
        x="3.5"
        y="5"
        width="17"
        height="15"
        rx="3"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path
        d="M3.5 9.5h17M8 3.5V6M16 3.5V6"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
}

function TrainIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" {...props}>
      <path
        d="M4.5 9.5v5M7.5 7.5v9M16.5 7.5v9M19.5 9.5v5M7.5 12h9"
        stroke="currentColor"
        strokeWidth="2.1"
        strokeLinecap="round"
      />
    </svg>
  );
}

function InsightsIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" {...props}>
      <path
        d="M4 19.5V13M9.33 19.5V8.5M14.67 19.5v-5M20 19.5V5"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
      />
    </svg>
  );
}

function CoachIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" {...props}>
      <path
        d="M11 3.5 12.7 8 17 9.7l-4.3 1.8L11 16l-1.7-4.5L5 9.7 9.3 8 11 3.5Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 14.5l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8.8-2Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Five logical destinations, in the canonical order. `end` is only correct for
// `/`; every other tab keeps its nested-route active behaviour (`/program/all`
// still lights PROGRAM up).
const TABS = [
  { to: "/", label: "Home", Icon: HomeIcon, end: true },
  { to: "/program", label: "Program", Icon: ProgramIcon },
  { to: "/train", label: "Train", Icon: TrainIcon, emphasis: "train" },
  { to: "/progress", label: "Insights", Icon: InsightsIcon },
  { to: "/ai", label: "Coach", Icon: CoachIcon },
];

function Tab({ to, label, Icon, end = false, emphasis }) {
  const isTrain = emphasis === "train";

  return (
    <NavLink
      to={to}
      end={end}
      className={`lz-tabbar__tab${isTrain ? " lz-tabbar__tab--train" : ""}`}
    >
      {isTrain ? (
        <span className="lz-tabbar__train-button">
          <Icon className="lz-tabbar__icon" />
        </span>
      ) : (
        <Icon className="lz-tabbar__icon" />
      )}
      <span className="lz-tabbar__label">{label}</span>
    </NavLink>
  );
}

export default function BottomTabs() {
  return (
    <DesignV2Scope as="nav" className="lz-tabbar" aria-label="Primary">
      {/* Decorative progressive scrim; must precede the bar so the bar paints
          on top of it. */}
      <span className="lz-tabbar__scrim" aria-hidden="true" />
      <div className="lz-tabbar__bar">
        {TABS.map((tab) => (
          <Tab key={tab.to} {...tab} />
        ))}
      </div>
    </DesignV2Scope>
  );
}
